define('app/views/defaultAnalytics/dining',["underscore"], function (_) {
  return {
    requestDiningReservationSelection: function (venueName, diningRes) {
      var diningVenues =
        diningRes.DiningVenues && diningRes.DiningVenues.DiningVenue;
      var selectedDining = _.find(diningVenues || [], function (venue) {
        return venue && venue.VenueName === venueName;
      });

      if (selectedDining) {
        gtag("event", "view_item_list", {
          item_list_id: "Dining-"+ venueName,
          item_list_name: "Dining",
          items: _.map(selectedDining.Setup.Areas || [], function (area) {
            return {
              item_id: area.Id,
              item_name: area.Name,
              item_category: venueName,
            };
          }),
        });
      }
    },
  };
});

